import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { AssignmentViewModel } from 'src/app/shared/models/autogenerated';
import { getAssignments } from '../../store/global-settings.actions';
import { selectAllAssignments } from '../../store/global-settings.selectors';
import { AssignmentsContactsTableComponent } from '../../components/assignments-contacts-table/assignments-contacts-table.component';
import { AssignmentsPhasesTableComponent } from '../../components/assignments-phases-table/assignments-phases-table.component';

@Component({
  standalone: false,
  selector: 'app-assignments-dashboard',
  templateUrl: './assignments-dashboard.component.html',
  styleUrl: './assignments-dashboard.component.scss',
})
export class AssignmentsDashboardComponent implements OnDestroy {
  allAssignments: AssignmentViewModel[] = [];
  allPhases: AssignmentViewModel[] = [];
  assignments: AssignmentViewModel[] = [];
  phases: AssignmentViewModel[] = [];

  private readonly subscription = new Subscription();

  constructor(private store: Store<AppState>) {
    this.store.dispatch(getAssignments());

    this.subscription.add(
      this.store.pipe(select(selectAllAssignments)).subscribe((data) => {
        const assignments = data || [];
        this.assignments = [...assignments];
        this.phases = [...assignments];
        this.allAssignments = [...assignments];
        this.allPhases = [...assignments];
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @ViewChild(AssignmentsContactsTableComponent)
  contactsTable!: AssignmentsContactsTableComponent;

  @ViewChild(AssignmentsPhasesTableComponent)
  phasesTable!: AssignmentsPhasesTableComponent;

  onFilterByUserRole({ userId, role }: { userId: string; role: string }) {
    this.phases = this.allPhases.filter(
      (phase) => phase.userId === userId && phase.role === role
    );
  }

  onFilterByProjectPhase({
    projectTitle,
    phaseId,
  }: {
    projectTitle: string;
    phaseId: string;
  }) {
    this.assignments = this.allAssignments.filter(
      (assignment) =>
        assignment.project?.name === projectTitle &&
        assignment.phase?.phaseId === phaseId
    );
  }

  clearAllFilters() {
    this.assignments = [...this.allAssignments];
    this.phases = [...this.allPhases];
  }
}
